export const commonTranslations = {
  en: {
    actions: {
      save: 'Save',
      cancel: 'Cancel',
      confirm: 'Confirm',
      close: 'Close',
      add: 'Add',
      edit: 'Edit',
      delete: 'Delete',
      remove: 'Remove',
      create: 'Create',
      update: 'Update',
      upload: 'Upload',
      download: 'Download',
      search: 'Search',
      filter: 'Filter',
      clear: 'Clear',
      reset: 'Reset',
      select: 'Select',
      selectAll: 'Select All',
      deselectAll: 'Deselect All',
      back: 'Back',
      next: 'Next',
      previous: 'Previous',
      submit: 'Submit',
      apply: 'Apply',
      view: 'View',
      copy: 'Copy',
      export: 'Export',
      import: 'Import',
      send: 'Send',
      refresh: 'Refresh',
      retry: 'Retry',
      continue: 'Continue',
      finish: 'Finish',
      start: 'Start',
      stop: 'Stop',
      pause: 'Pause',
      resume: 'Resume',
      enable: 'Enable',
      disable: 'Disable',
      activate: 'Activate',
      deactivate: 'Deactivate',
      archive: 'Archive',
      restore: 'Restore',
      duplicate: 'Duplicate',
      clone: 'Clone',
      move: 'Move',
      rename: 'Rename',
      print: 'Print',
      preview: 'Preview',
      open: 'Open',
      openInNewTab: 'Open in new tab',
      goTo: 'Go to',
      showMore: 'Show more',
      showLess: 'Show less',
      expand: 'Expand',
      collapse: 'Collapse',
      yes: 'Yes',
      no: 'No',
      ok: 'OK',
      done: 'Done',
      share: 'Share',
      link: 'Link',
      unlink: 'Unlink',
      connect: 'Connect',
      disconnect: 'Disconnect',
      sync: 'Sync',
      syncing: 'Syncing...',
      assign: 'Assign',
      unassign: 'Unassign',
      complete: 'Complete',
      incomplete: 'Incomplete',
      approve: 'Approve',
      reject: 'Reject',
      accept: 'Accept',
      decline: 'Decline',
      manage: 'Manage',
      configure: 'Configure',
      customize: 'Customize',
      install: 'Install',
      uninstall: 'Uninstall',
      login: 'Login',
      logout: 'Logout',
      register: 'Register',
      signUp: 'Sign Up',
      signIn: 'Sign In',
      signOut: 'Sign Out',
      forgotPassword: 'Forgot Password',
      resetPassword: 'Reset Password',
      changePassword: 'Change Password'
    },
    status: {
      loading: 'Loading...',
      saving: 'Saving...',
      deleting: 'Deleting...',
      uploading: 'Uploading...',
      downloading: 'Downloading...',
      processing: 'Processing...',
      syncing: 'Syncing...',
      sending: 'Sending...',
      searching: 'Searching...',
      updating: 'Updating...',
      creating: 'Creating...',
      importing: 'Importing...',
      exporting: 'Exporting...',
      success: 'Success',
      error: 'Error',
      warning: 'Warning',
      info: 'Info',
      pending: 'Pending',
      completed: 'Completed',
      failed: 'Failed',
      cancelled: 'Cancelled',
      active: 'Active',
      inactive: 'Inactive',
      enabled: 'Enabled',
      disabled: 'Disabled',
      archived: 'Archived',
      draft: 'Draft',
      published: 'Published',
      approved: 'Approved',
      rejected: 'Rejected',
      inProgress: 'In Progress',
      onHold: 'On Hold',
      open: 'Open',
      closed: 'Closed',
      new: 'New',
      used: 'Used',
      available: 'Available',
      unavailable: 'Unavailable',
      online: 'Online',
      offline: 'Offline',
      connected: 'Connected',
      disconnected: 'Disconnected',
      verified: 'Verified',
      unverified: 'Unverified',
      valid: 'Valid',
      invalid: 'Invalid',
      expired: 'Expired',
      scheduled: 'Scheduled',
      overdue: 'Overdue',
      paid: 'Paid',
      unpaid: 'Unpaid',
      partial: 'Partial'
    },
    messages: {
      noResults: 'No results found',
      noData: 'No data available',
      noItems: 'No items',
      empty: 'Empty',
      required: 'This field is required',
      invalidEmail: 'Invalid email format',
      invalidPhone: 'Invalid phone format',
      invalidUrl: 'Invalid URL format',
      minLength: 'Minimum {min} characters required',
      maxLength: 'Maximum {max} characters allowed',
      confirmDelete: 'Are you sure you want to delete this item?',
      confirmDeleteMultiple: 'Are you sure you want to delete the selected items?',
      confirmCancel: 'Are you sure you want to cancel? Unsaved changes will be lost.',
      confirmArchive: 'Are you sure you want to archive this item?',
      unsavedChanges: 'You have unsaved changes. Do you want to save before leaving?',
      operationSuccess: 'Operation completed successfully',
      operationError: 'An error occurred. Please try again.',
      saveSuccess: 'Saved successfully',
      saveError: 'Error saving. Please try again.',
      deleteSuccess: 'Deleted successfully',
      deleteError: 'Error deleting. Please try again.',
      createSuccess: 'Created successfully',
      createError: 'Error creating. Please try again.',
      updateSuccess: 'Updated successfully',
      updateError: 'Error updating. Please try again.',
      uploadSuccess: 'Uploaded successfully',
      uploadError: 'Error uploading. Please try again.',
      downloadSuccess: 'Downloaded successfully',
      downloadError: 'Error downloading. Please try again.',
      importSuccess: 'Imported successfully',
      importError: 'Error importing. Please try again.',
      exportSuccess: 'Exported successfully',
      exportError: 'Error exporting. Please try again.',
      sendSuccess: 'Sent successfully',
      sendError: 'Error sending. Please try again.',
      copySuccess: 'Copied to clipboard',
      copyError: 'Error copying. Please try again.',
      networkError: 'Network error. Please check your connection.',
      serverError: 'Server error. Please try again later.',
      sessionExpired: 'Session expired. Please login again.',
      permissionDenied: 'Permission denied',
      notFound: 'Not found',
      alreadyExists: 'Already exists',
      invalidData: 'Invalid data provided',
      loadingError: 'Error loading data',
      selectOption: 'Please select an option',
      enterValue: 'Please enter a value',
      searchPlaceholder: 'Search...',
      filterPlaceholder: 'Filter...',
      noMatchingResults: 'No matching results',
      tryDifferentSearch: 'Try a different search term',
      loadMore: 'Load more',
      endOfList: 'End of list',
      itemsSelected: '{count} items selected',
      allItemsSelected: 'All items selected',
      noneSelected: 'None selected',
      of: 'of',
      to: 'to'
    },
    labels: {
      id: 'ID',
      name: 'Name',
      firstName: 'First Name',
      lastName: 'Last Name',
      fullName: 'Full Name',
      email: 'Email',
      phone: 'Phone',
      mobile: 'Mobile',
      address: 'Address',
      city: 'City',
      province: 'Province',
      region: 'Region',
      country: 'Country',
      postalCode: 'Postal Code',
      description: 'Description',
      title: 'Title',
      subtitle: 'Subtitle',
      date: 'Date',
      time: 'Time',
      dateTime: 'Date & Time',
      startDate: 'Start Date',
      endDate: 'End Date',
      dueDate: 'Due Date',
      createdAt: 'Created At',
      updatedAt: 'Updated At',
      createdBy: 'Created By',
      updatedBy: 'Updated By',
      status: 'Status',
      type: 'Type',
      category: 'Category',
      subcategory: 'Subcategory',
      tags: 'Tags',
      priority: 'Priority',
      amount: 'Amount',
      quantity: 'Quantity',
      price: 'Price',
      unitPrice: 'Unit Price',
      total: 'Total',
      subtotal: 'Subtotal',
      tax: 'Tax',
      vat: 'VAT',
      discount: 'Discount',
      currency: 'Currency',
      notes: 'Notes',
      comments: 'Comments',
      attachments: 'Attachments',
      files: 'Files',
      images: 'Images',
      documents: 'Documents',
      actions: 'Actions',
      options: 'Options',
      settings: 'Settings',
      preferences: 'Preferences',
      details: 'Details',
      summary: 'Summary',
      overview: 'Overview',
      history: 'History',
      logs: 'Logs',
      activity: 'Activity',
      user: 'User',
      users: 'Users',
      role: 'Role',
      roles: 'Roles',
      permission: 'Permission',
      permissions: 'Permissions',
      organization: 'Organization',
      company: 'Company',
      client: 'Client',
      clients: 'Clients',
      customer: 'Customer',
      customers: 'Customers',
      contact: 'Contact',
      contacts: 'Contacts',
      lead: 'Lead',
      leads: 'Leads',
      deal: 'Deal',
      deals: 'Deals',
      project: 'Project',
      projects: 'Projects',
      task: 'Task',
      tasks: 'Tasks',
      service: 'Service',
      services: 'Services',
      product: 'Product',
      products: 'Products',
      order: 'Order',
      orders: 'Orders',
      invoice: 'Invoice',
      invoices: 'Invoices',
      payment: 'Payment',
      payments: 'Payments',
      report: 'Report',
      reports: 'Reports',
      dashboard: 'Dashboard',
      calendar: 'Calendar',
      schedule: 'Schedule',
      notification: 'Notification',
      notifications: 'Notifications',
      message: 'Message',
      messages: 'Messages',
      template: 'Template',
      templates: 'Templates',
      version: 'Version',
      language: 'Language',
      theme: 'Theme',
      color: 'Color',
      size: 'Size',
      width: 'Width',
      height: 'Height',
      weight: 'Weight',
      duration: 'Duration',
      progress: 'Progress',
      percentage: 'Percentage',
      ratio: 'Ratio',
      rate: 'Rate',
      code: 'Code',
      reference: 'Reference',
      number: 'Number',
      serial: 'Serial',
      barcode: 'Barcode',
      sku: 'SKU',
      url: 'URL',
      link: 'Link',
      website: 'Website',
      source: 'Source',
      origin: 'Origin',
      destination: 'Destination',
      from: 'From',
      to: 'To',
      by: 'By',
      for: 'For',
      with: 'With',
      without: 'Without',
      before: 'Before',
      after: 'After',
      between: 'Between',
      all: 'All',
      none: 'None',
      any: 'Any',
      other: 'Other',
      default: 'Default',
      custom: 'Custom',
      general: 'General',
      advanced: 'Advanced',
      basic: 'Basic',
      optional: 'Optional',
      mandatory: 'Mandatory',
      public: 'Public',
      private: 'Private',
      internal: 'Internal',
      external: 'External',
      fiscalCode: 'Fiscal Code',
      vatNumber: 'VAT Number',
      businessName: 'Business Name'
    },
    pagination: {
      showing: 'Showing',
      of: 'of',
      to: 'to',
      results: 'results',
      items: 'items',
      entries: 'entries',
      records: 'records',
      page: 'Page',
      pages: 'Pages',
      perPage: 'Per page',
      itemsPerPage: 'Items per page',
      first: 'First',
      last: 'Last',
      previous: 'Previous',
      next: 'Next',
      goToPage: 'Go to page',
      showingXofY: 'Showing {from} to {to} of {total}',
      noResultsToShow: 'No results to show'
    },
    time: {
      today: 'Today',
      yesterday: 'Yesterday',
      tomorrow: 'Tomorrow',
      thisWeek: 'This week',
      lastWeek: 'Last week',
      nextWeek: 'Next week',
      thisMonth: 'This month',
      lastMonth: 'Last month',
      nextMonth: 'Next month',
      thisYear: 'This year',
      lastYear: 'Last year',
      nextYear: 'Next year',
      now: 'Now',
      ago: 'ago',
      in: 'in',
      seconds: 'seconds',
      minutes: 'minutes',
      hours: 'hours',
      days: 'days',
      weeks: 'weeks',
      months: 'months',
      years: 'years',
      second: 'second',
      minute: 'minute',
      hour: 'hour',
      day: 'day',
      week: 'week',
      month: 'month',
      year: 'year',
      morning: 'Morning',
      afternoon: 'Afternoon',
      evening: 'Evening',
      night: 'Night',
      daily: 'Daily',
      weekly: 'Weekly',
      monthly: 'Monthly',
      yearly: 'Yearly',
      annually: 'Annually'
    },
    units: {
      currency: {
        euro: 'Euro',
        dollar: 'Dollar',
        pound: 'Pound'
      },
      weight: {
        kg: 'kg',
        g: 'g',
        lb: 'lb',
        oz: 'oz'
      },
      length: {
        m: 'm',
        cm: 'cm',
        mm: 'mm',
        km: 'km',
        in: 'in',
        ft: 'ft'
      },
      volume: {
        l: 'L',
        ml: 'mL',
        gal: 'gal'
      },
      area: {
        sqm: 'sqm',
        sqft: 'sqft'
      }
    },
    files: {
      upload: 'Upload file',
      uploadMultiple: 'Upload files',
      download: 'Download file',
      delete: 'Delete file',
      preview: 'Preview file',
      dragAndDrop: 'Drag and drop files here',
      orClickToSelect: 'or click to select',
      maxFileSize: 'Maximum file size: {size}',
      allowedFormats: 'Allowed formats: {formats}',
      fileSize: 'File size',
      fileName: 'File name',
      fileType: 'File type',
      noFilesSelected: 'No files selected',
      filesSelected: '{count} files selected',
      uploadProgress: 'Uploading: {progress}%',
      uploadComplete: 'Upload complete',
      uploadFailed: 'Upload failed',
      fileTooLarge: 'File too large',
      invalidFormat: 'Invalid file format',
      processing: 'Processing file...'
    },
    errors: {
      generic: 'An error occurred',
      network: 'Network error',
      server: 'Server error',
      notFound: 'Not found',
      unauthorized: 'Unauthorized',
      forbidden: 'Access denied',
      validation: 'Validation error',
      timeout: 'Request timeout',
      conflict: 'Conflict',
      tooManyRequests: 'Too many requests. Please try again later.',
      serviceUnavailable: 'Service temporarily unavailable',
      unexpectedError: 'An unexpected error occurred. Please try again.',
      tryAgain: 'Please try again',
      contactSupport: 'If the problem persists, contact support'
    },
    confirmations: {
      delete: {
        title: 'Confirm Delete',
        message: 'Are you sure you want to delete this item? This action cannot be undone.',
        confirm: 'Delete',
        cancel: 'Cancel'
      },
      archive: {
        title: 'Confirm Archive',
        message: 'Are you sure you want to archive this item?',
        confirm: 'Archive',
        cancel: 'Cancel'
      },
      discard: {
        title: 'Discard Changes',
        message: 'You have unsaved changes. Are you sure you want to discard them?',
        confirm: 'Discard',
        cancel: 'Keep Editing'
      },
      logout: {
        title: 'Confirm Logout',
        message: 'Are you sure you want to logout?',
        confirm: 'Logout',
        cancel: 'Cancel'
      }
    }
  },
  it: {
    actions: {
      save: 'Salva',
      cancel: 'Annulla',
      confirm: 'Conferma',
      close: 'Chiudi',
      add: 'Aggiungi',
      edit: 'Modifica',
      delete: 'Elimina',
      remove: 'Rimuovi',
      create: 'Crea',
      update: 'Aggiorna',
      upload: 'Carica',
      download: 'Scarica',
      search: 'Cerca',
      filter: 'Filtra',
      clear: 'Cancella',
      reset: 'Reimposta',
      select: 'Seleziona',
      selectAll: 'Seleziona tutto',
      deselectAll: 'Deseleziona tutto',
      back: 'Indietro',
      next: 'Avanti',
      previous: 'Precedente',
      submit: 'Invia',
      apply: 'Applica',
      view: 'Visualizza',
      copy: 'Copia',
      export: 'Esporta',
      import: 'Importa',
      send: 'Invia',
      refresh: 'Aggiorna',
      retry: 'Riprova',
      continue: 'Continua',
      finish: 'Termina',
      start: 'Inizia',
      stop: 'Ferma',
      pause: 'Pausa',
      resume: 'Riprendi',
      enable: 'Abilita',
      disable: 'Disabilita',
      activate: 'Attiva',
      deactivate: 'Disattiva',
      archive: 'Archivia',
      restore: 'Ripristina',
      duplicate: 'Duplica',
      clone: 'Clona',
      move: 'Sposta',
      rename: 'Rinomina',
      print: 'Stampa',
      preview: 'Anteprima',
      open: 'Apri',
      openInNewTab: 'Apri in nuova scheda',
      goTo: 'Vai a',
      showMore: 'Mostra di più',
      showLess: 'Mostra di meno',
      expand: 'Espandi',
      collapse: 'Comprimi',
      yes: 'Sì',
      no: 'No',
      ok: 'OK',
      done: 'Fatto',
      share: 'Condividi',
      link: 'Collega',
      unlink: 'Scollega',
      connect: 'Connetti',
      disconnect: 'Disconnetti',
      sync: 'Sincronizza',
      syncing: 'Sincronizzazione...',
      assign: 'Assegna',
      unassign: 'Rimuovi assegnazione',
      complete: 'Completa',
      incomplete: 'Incompleto',
      approve: 'Approva',
      reject: 'Rifiuta',
      accept: 'Accetta',
      decline: 'Rifiuta',
      manage: 'Gestisci',
      configure: 'Configura',
      customize: 'Personalizza',
      install: 'Installa',
      uninstall: 'Disinstalla',
      login: 'Accedi',
      logout: 'Esci',
      register: 'Registrati',
      signUp: 'Registrati',
      signIn: 'Accedi',
      signOut: 'Esci',
      forgotPassword: 'Password dimenticata',
      resetPassword: 'Reimposta password',
      changePassword: 'Cambia password'
    },
    status: {
      loading: 'Caricamento...',
      saving: 'Salvataggio...',
      deleting: 'Eliminazione...',
      uploading: 'Caricamento...',
      downloading: 'Download...',
      processing: 'Elaborazione...',
      syncing: 'Sincronizzazione...',
      sending: 'Invio...',
      searching: 'Ricerca...',
      updating: 'Aggiornamento...',
      creating: 'Creazione...',
      importing: 'Importazione...',
      exporting: 'Esportazione...',
      success: 'Successo',
      error: 'Errore',
      warning: 'Attenzione',
      info: 'Info',
      pending: 'In attesa',
      completed: 'Completato',
      failed: 'Fallito',
      cancelled: 'Annullato',
      active: 'Attivo',
      inactive: 'Inattivo',
      enabled: 'Abilitato',
      disabled: 'Disabilitato',
      archived: 'Archiviato',
      draft: 'Bozza',
      published: 'Pubblicato',
      approved: 'Approvato',
      rejected: 'Rifiutato',
      inProgress: 'In corso',
      onHold: 'In sospeso',
      open: 'Aperto',
      closed: 'Chiuso',
      new: 'Nuovo',
      used: 'Usato',
      available: 'Disponibile',
      unavailable: 'Non disponibile',
      online: 'Online',
      offline: 'Offline',
      connected: 'Connesso',
      disconnected: 'Disconnesso',
      verified: 'Verificato',
      unverified: 'Non verificato',
      valid: 'Valido',
      invalid: 'Non valido',
      expired: 'Scaduto',
      scheduled: 'Programmato',
      overdue: 'Scaduto',
      paid: 'Pagato',
      unpaid: 'Non pagato',
      partial: 'Parziale'
    },
    messages: {
      noResults: 'Nessun risultato trovato',
      noData: 'Nessun dato disponibile',
      noItems: 'Nessun elemento',
      empty: 'Vuoto',
      required: 'Questo campo è obbligatorio',
      invalidEmail: 'Formato email non valido',
      invalidPhone: 'Formato telefono non valido',
      invalidUrl: 'Formato URL non valido',
      minLength: 'Minimo {min} caratteri richiesti',
      maxLength: 'Massimo {max} caratteri consentiti',
      confirmDelete: 'Sei sicuro di voler eliminare questo elemento?',
      confirmDeleteMultiple: 'Sei sicuro di voler eliminare gli elementi selezionati?',
      confirmCancel: 'Sei sicuro di voler annullare? Le modifiche non salvate andranno perse.',
      confirmArchive: 'Sei sicuro di voler archiviare questo elemento?',
      unsavedChanges: 'Hai modifiche non salvate. Vuoi salvare prima di uscire?',
      operationSuccess: 'Operazione completata con successo',
      operationError: 'Si è verificato un errore. Riprova.',
      saveSuccess: 'Salvato con successo',
      saveError: 'Errore nel salvataggio. Riprova.',
      deleteSuccess: 'Eliminato con successo',
      deleteError: 'Errore nell\'eliminazione. Riprova.',
      createSuccess: 'Creato con successo',
      createError: 'Errore nella creazione. Riprova.',
      updateSuccess: 'Aggiornato con successo',
      updateError: 'Errore nell\'aggiornamento. Riprova.',
      uploadSuccess: 'Caricato con successo',
      uploadError: 'Errore nel caricamento. Riprova.',
      downloadSuccess: 'Scaricato con successo',
      downloadError: 'Errore nel download. Riprova.',
      importSuccess: 'Importato con successo',
      importError: 'Errore nell\'importazione. Riprova.',
      exportSuccess: 'Esportato con successo',
      exportError: 'Errore nell\'esportazione. Riprova.',
      sendSuccess: 'Inviato con successo',
      sendError: 'Errore nell\'invio. Riprova.',
      copySuccess: 'Copiato negli appunti',
      copyError: 'Errore nella copia. Riprova.',
      networkError: 'Errore di rete. Verifica la connessione.',
      serverError: 'Errore del server. Riprova più tardi.',
      sessionExpired: 'Sessione scaduta. Effettua nuovamente l\'accesso.',
      permissionDenied: 'Permesso negato',
      notFound: 'Non trovato',
      alreadyExists: 'Esiste già',
      invalidData: 'Dati non validi',
      loadingError: 'Errore nel caricamento dei dati',
      selectOption: 'Seleziona un\'opzione',
      enterValue: 'Inserisci un valore',
      searchPlaceholder: 'Cerca...',
      filterPlaceholder: 'Filtra...',
      noMatchingResults: 'Nessun risultato corrispondente',
      tryDifferentSearch: 'Prova con un termine di ricerca diverso',
      loadMore: 'Carica altri',
      endOfList: 'Fine della lista',
      itemsSelected: '{count} elementi selezionati',
      allItemsSelected: 'Tutti gli elementi selezionati',
      noneSelected: 'Nessuna selezione',
      of: 'di',
      to: 'a'
    },
    labels: {
      id: 'ID',
      name: 'Nome',
      firstName: 'Nome',
      lastName: 'Cognome',
      fullName: 'Nome completo',
      email: 'Email',
      phone: 'Telefono',
      mobile: 'Cellulare',
      address: 'Indirizzo',
      city: 'Città',
      province: 'Provincia',
      region: 'Regione',
      country: 'Paese',
      postalCode: 'CAP',
      description: 'Descrizione',
      title: 'Titolo',
      subtitle: 'Sottotitolo',
      date: 'Data',
      time: 'Ora',
      dateTime: 'Data e ora',
      startDate: 'Data inizio',
      endDate: 'Data fine',
      dueDate: 'Data scadenza',
      createdAt: 'Creato il',
      updatedAt: 'Aggiornato il',
      createdBy: 'Creato da',
      updatedBy: 'Aggiornato da',
      status: 'Stato',
      type: 'Tipo',
      category: 'Categoria',
      subcategory: 'Sottocategoria',
      tags: 'Tag',
      priority: 'Priorità',
      amount: 'Importo',
      quantity: 'Quantità',
      price: 'Prezzo',
      unitPrice: 'Prezzo unitario',
      total: 'Totale',
      subtotal: 'Subtotale',
      tax: 'Tasse',
      vat: 'IVA',
      discount: 'Sconto',
      currency: 'Valuta',
      notes: 'Note',
      comments: 'Commenti',
      attachments: 'Allegati',
      files: 'File',
      images: 'Immagini',
      documents: 'Documenti',
      actions: 'Azioni',
      options: 'Opzioni',
      settings: 'Impostazioni',
      preferences: 'Preferenze',
      details: 'Dettagli',
      summary: 'Riepilogo',
      overview: 'Panoramica',
      history: 'Cronologia',
      logs: 'Log',
      activity: 'Attività',
      user: 'Utente',
      users: 'Utenti',
      role: 'Ruolo',
      roles: 'Ruoli',
      permission: 'Permesso',
      permissions: 'Permessi',
      organization: 'Organizzazione',
      company: 'Azienda',
      client: 'Cliente',
      clients: 'Clienti',
      customer: 'Cliente',
      customers: 'Clienti',
      contact: 'Contatto',
      contacts: 'Contatti',
      lead: 'Lead',
      leads: 'Lead',
      deal: 'Offerta',
      deals: 'Offerte',
      project: 'Progetto',
      projects: 'Progetti',
      task: 'Attività',
      tasks: 'Attività',
      service: 'Servizio',
      services: 'Servizi',
      product: 'Prodotto',
      products: 'Prodotti',
      order: 'Ordine',
      orders: 'Ordini',
      invoice: 'Fattura',
      invoices: 'Fatture',
      payment: 'Pagamento',
      payments: 'Pagamenti',
      report: 'Report',
      reports: 'Report',
      dashboard: 'Dashboard',
      calendar: 'Calendario',
      schedule: 'Programmazione',
      notification: 'Notifica',
      notifications: 'Notifiche',
      message: 'Messaggio',
      messages: 'Messaggi',
      template: 'Modello',
      templates: 'Modelli',
      version: 'Versione',
      language: 'Lingua',
      theme: 'Tema',
      color: 'Colore',
      size: 'Dimensione',
      width: 'Larghezza',
      height: 'Altezza',
      weight: 'Peso',
      duration: 'Durata',
      progress: 'Progresso',
      percentage: 'Percentuale',
      ratio: 'Rapporto',
      rate: 'Tariffa',
      code: 'Codice',
      reference: 'Riferimento',
      number: 'Numero',
      serial: 'Seriale',
      barcode: 'Codice a barre',
      sku: 'SKU',
      url: 'URL',
      link: 'Link',
      website: 'Sito web',
      source: 'Fonte',
      origin: 'Origine',
      destination: 'Destinazione',
      from: 'Da',
      to: 'A',
      by: 'Da',
      for: 'Per',
      with: 'Con',
      without: 'Senza',
      before: 'Prima',
      after: 'Dopo',
      between: 'Tra',
      all: 'Tutti',
      none: 'Nessuno',
      any: 'Qualsiasi',
      other: 'Altro',
      default: 'Predefinito',
      custom: 'Personalizzato',
      general: 'Generale',
      advanced: 'Avanzato',
      basic: 'Base',
      optional: 'Opzionale',
      mandatory: 'Obbligatorio',
      public: 'Pubblico',
      private: 'Privato',
      internal: 'Interno',
      external: 'Esterno',
      fiscalCode: 'Codice Fiscale',
      vatNumber: 'Partita IVA',
      businessName: 'Ragione Sociale'
    },
    pagination: {
      showing: 'Visualizzazione',
      of: 'di',
      to: 'a',
      results: 'risultati',
      items: 'elementi',
      entries: 'voci',
      records: 'record',
      page: 'Pagina',
      pages: 'Pagine',
      perPage: 'Per pagina',
      itemsPerPage: 'Elementi per pagina',
      first: 'Prima',
      last: 'Ultima',
      previous: 'Precedente',
      next: 'Successiva',
      goToPage: 'Vai alla pagina',
      showingXofY: 'Visualizzazione da {from} a {to} di {total}',
      noResultsToShow: 'Nessun risultato da visualizzare'
    },
    time: {
      today: 'Oggi',
      yesterday: 'Ieri',
      tomorrow: 'Domani',
      thisWeek: 'Questa settimana',
      lastWeek: 'Settimana scorsa',
      nextWeek: 'Prossima settimana',
      thisMonth: 'Questo mese',
      lastMonth: 'Mese scorso',
      nextMonth: 'Prossimo mese',
      thisYear: 'Quest\'anno',
      lastYear: 'Anno scorso',
      nextYear: 'Prossimo anno',
      now: 'Adesso',
      ago: 'fa',
      in: 'tra',
      seconds: 'secondi',
      minutes: 'minuti',
      hours: 'ore',
      days: 'giorni',
      weeks: 'settimane',
      months: 'mesi',
      years: 'anni',
      second: 'secondo',
      minute: 'minuto',
      hour: 'ora',
      day: 'giorno',
      week: 'settimana',
      month: 'mese',
      year: 'anno',
      morning: 'Mattina',
      afternoon: 'Pomeriggio',
      evening: 'Sera',
      night: 'Notte',
      daily: 'Giornaliero',
      weekly: 'Settimanale',
      monthly: 'Mensile',
      yearly: 'Annuale',
      annually: 'Annuale'
    },
    units: {
      currency: {
        euro: 'Euro',
        dollar: 'Dollaro',
        pound: 'Sterlina'
      },
      weight: {
        kg: 'kg',
        g: 'g',
        lb: 'lb',
        oz: 'oz'
      },
      length: {
        m: 'm',
        cm: 'cm',
        mm: 'mm',
        km: 'km',
        in: 'in',
        ft: 'ft'
      },
      volume: {
        l: 'L',
        ml: 'mL',
        gal: 'gal'
      },
      area: {
        sqm: 'mq',
        sqft: 'sqft'
      }
    },
    files: {
      upload: 'Carica file',
      uploadMultiple: 'Carica file',
      download: 'Scarica file',
      delete: 'Elimina file',
      preview: 'Anteprima file',
      dragAndDrop: 'Trascina e rilascia i file qui',
      orClickToSelect: 'o clicca per selezionare',
      maxFileSize: 'Dimensione massima file: {size}',
      allowedFormats: 'Formati consentiti: {formats}',
      fileSize: 'Dimensione file',
      fileName: 'Nome file',
      fileType: 'Tipo file',
      noFilesSelected: 'Nessun file selezionato',
      filesSelected: '{count} file selezionati',
      uploadProgress: 'Caricamento: {progress}%',
      uploadComplete: 'Caricamento completato',
      uploadFailed: 'Caricamento fallito',
      fileTooLarge: 'File troppo grande',
      invalidFormat: 'Formato file non valido',
      processing: 'Elaborazione file...'
    },
    errors: {
      generic: 'Si è verificato un errore',
      network: 'Errore di rete',
      server: 'Errore del server',
      notFound: 'Non trovato',
      unauthorized: 'Non autorizzato',
      forbidden: 'Accesso negato',
      validation: 'Errore di validazione',
      timeout: 'Timeout della richiesta',
      conflict: 'Conflitto',
      tooManyRequests: 'Troppe richieste. Riprova più tardi.',
      serviceUnavailable: 'Servizio temporaneamente non disponibile',
      unexpectedError: 'Si è verificato un errore imprevisto. Riprova.',
      tryAgain: 'Riprova',
      contactSupport: 'Se il problema persiste, contatta l\'assistenza'
    },
    confirmations: {
      delete: {
        title: 'Conferma eliminazione',
        message: 'Sei sicuro di voler eliminare questo elemento? Questa azione non può essere annullata.',
        confirm: 'Elimina',
        cancel: 'Annulla'
      },
      archive: {
        title: 'Conferma archiviazione',
        message: 'Sei sicuro di voler archiviare questo elemento?',
        confirm: 'Archivia',
        cancel: 'Annulla'
      },
      discard: {
        title: 'Scarta modifiche',
        message: 'Hai modifiche non salvate. Sei sicuro di volerle scartare?',
        confirm: 'Scarta',
        cancel: 'Continua a modificare'
      },
      logout: {
        title: 'Conferma logout',
        message: 'Sei sicuro di voler uscire?',
        confirm: 'Esci',
        cancel: 'Annulla'
      }
    }
  }
};
